import React, { forwardRef, useCallback, useMemo, useState } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import Rapid7InsightVMMappingForm from './Rapid7InsightVMMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
import { Alert } from 'antd';
import _, { isEmpty } from 'lodash';

const AUTH_TYPES_CONFIG = {
    ON_PREMISE: 'onPremise',
    CLOUD: 'cloud', 
}

function Rapid7InsightVMCredentialsForm(props, ref) {
    const featureFlags = useFeatureFlag();
    const [enableFetchAssets, setEnableFetchAssets] = useState();
    const [authenticationType, setAuthType] = useState(() => {
        if (!_.isEmpty(props.config) && _.isEmpty(props.config.username)) {
          return AUTH_TYPES_CONFIG.CLOUD
        }
        return AUTH_TYPES_CONFIG.ON_PREMISE
      });

    const handleRadioChange = useCallback((e) => {
        setAuthType(e.target.value);
    },[]);

    const onPremiseFields = useMemo(()=>([
        {
            name: "username",
            label: "Username",
            required: true
        }, {
            name: "password",
            label: "Password",
            type: FieldTypes.PASSWORD,
            props: {
                onChange: (e) => setEnableFetchAssets(!isEmpty(e.target.value))},
            required: true
        },]),[]);


    const cloudFields = useMemo(() => ([
    {
        name: "token",
        label: "Token",
        required: true,
        props: {
            onChange: (e) => setEnableFetchAssets(!isEmpty(e.target.value))},
        type: FieldTypes.PASSWORD,
    }, {
        name: "message",
        type: FieldTypes.LABEL,
        value: <Alert type='warning' message="Tag Names for this integration will be available after few minutes of adding the credentials, since they are pulled in background."/>
    }]),[]);


    const authField = authenticationType === AUTH_TYPES_CONFIG.CLOUD ? cloudFields : onPremiseFields;

    const fields = [
    {
        name: "authenticationType",
        type: FieldTypes.RADIO,
        options: [
            {
                label: 'On Premise',
                value: AUTH_TYPES_CONFIG.ON_PREMISE
            },
            {
                label: 'Cloud',
                value: AUTH_TYPES_CONFIG.CLOUD
            }
        ],
        props: {
            onChange: handleRadioChange,
            defaultValue: authenticationType,
        }
    },
    {
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules:[urlRegexValidator],
    },
    ...authField,
    ...(featureFlags.RBVM_ASSETS ? [{
        name: "fetchAssets",
        label: "Fetch Assets",
        type: FieldTypes.BOOLEAN,
        disabled: !enableFetchAssets,
        inline: true,
        }] : []
    )
]

    const parseExtraFields = useCallback((config) => {
        return {
            ...config,
            fetchAssets: config.fetchAssets === "true"
        }
    }, [])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            parseExtraFields = {parseExtraFields}
            MappingForm={Rapid7InsightVMMappingForm}
            initialValue={{ authenticationType: authenticationType, apiEndpoint: 'https://us.api.insight.rapid7.com' }}
        />
    )
}

export default forwardRef(Rapid7InsightVMCredentialsForm);